export function getDateString (date) {
    const fn = x => x > 9 ? x : '0' + x
    const y = date.getUTCFullYear()
    const m = fn(date.getUTCMonth() + 1)
    const d = fn(date.getUTCDate())
    return [y,m,d].join('-')
}

export function getDiffDays (dates) {
    const diffTime = dates[0] - dates[1]
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
}

export const normalizeDate = (date) => new Date(date.toISOString().slice(0,10))

// Today at the resort as a UTC midnight, the form the calendars compare dates in.
export function todayAt (timeZone, now = new Date) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
    let format
    try {
        format = new Intl.DateTimeFormat('en-US', { ...options, timeZone })
    } catch {
        format = new Intl.DateTimeFormat('en-US', options)
    }
    const { year, month, day } = Object.fromEntries(format.formatToParts(now).map(p => [p.type, Number(p.value)]))
    return new Date(Date.UTC(year, month - 1, day))
}
